'use client';

import { ShieldCheckIcon, BuildingOfficeIcon, TruckIcon } from '@heroicons/react/24/outline';

const CertificationSection = () => {
  const certifications = [
    {
      id: 1,
      title: 'Godkjent brukthandelbevilling (Norge)',
      icon: ShieldCheckIcon,
      description: 'Offisiell godkjenning fra norske myndigheter'
    },
    {
      id: 2,
      title: 'Registrert norsk foretak',
      icon: BuildingOfficeIcon,
      description: 'Registrert i Brønnøysundregistrene'
    },
    {
      id: 3,
      title: 'Sporbar og forsikret frakt',
      icon: TruckIcon,
      description: 'Full sporing og forsikring på alle forsendelser'
    }
  ];

  return (
    <section className="py-16 bg-white" id="sertifiseringer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
            Sertifiseringer og medlemskap
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {certifications?.map((cert) => (
            <div
              key={cert?.id}
              className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 flex flex-col items-center text-center"
            >
              <div className="mb-6">
                <cert.icon className="w-16 h-16 text-[#D4AF37] mx-auto" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {cert?.title}
              </h3>
              <p className="text-gray-600 text-sm">
                {cert?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationSection;